<template>
  <ContainerWithLabel :label="props.field.properties.label">
    <codemirror v-model="model" :options="editorOptions" />
  </ContainerWithLabel>
</template>
<script setup lang="ts">
import { Codemirror } from 'vue-codemirror'

import ContainerWithLabel from '../../ContainerWithLabel.vue'
import { SchemaFormKitProps } from './formkit/types'

const props = defineProps<SchemaFormKitProps>()
const model = defineModel<string>()
const editorOptions = {
  // codemirror options
  tabSize: 4,
  mode: {
    name: 'markdown',
  },
  theme: 'base16-light',
  lineNumbers: true,
  line: true,
}
</script>

<style>
:deep(.cm-scroller) {
  overflow: 'auto';
}

:deep(.cm-editor) {
  max-height: 400px;
  /* Adjust the codemirror editor height */
  min-height: 200px;
  background-color: #f5f5f5;
}
</style>
